// @flow

export const WagerTypesPos = {
  Win: 0,
  Place: 1,
  Show: 2
};

export const WagerTypes = {
  Win: 10,
  Place: 20,
  Show: 30,
  WinPlace: 40,
  WinShow: 50,
  PlaceShow: 60,
  WinPlaceShow: 70,
  Quinella: 80,
  Exacta: 110,
  DailyDouble: 310
};

export const WagerTypesMap = {
  Win: { id: WagerTypes.Win, code: "WN" },
  Place: { id: WagerTypes.Place, code: "PL" },
  Show: { id: WagerTypes.Show, code: "SH" },
  WinPlace: { id: WagerTypes.WinPlace, code: "WP" },
  WinShow: { id: WagerTypes.WinShow, code: "WS" },
  PlaceShow: { id: WagerTypes.PlaceShow, code: "PS" },
  WinPlaceShow: { id: WagerTypes.WinPlaceShow, code: "WPS" },
  Quinella: { id: WagerTypes.Quinella, code: "QN" },
  Exacta: { id: WagerTypes.Exacta, code: "EX" },
  DailyDouble: { id: WagerTypes.DailyDouble, code: "DB" }
};

export const WagerTypesGroup = {
  WinPlaceShow: [
    WagerTypes.Win,
    WagerTypes.WinPlace,
    WagerTypes.WinShow,
    WagerTypes.WinPlaceShow,
    WagerTypes.Show,
    WagerTypes.Place
  ]
};

export type WagerGroupEnum = "winGroup";

export const WagerGroupNames = {
  winGroup: {
    names: ["Win", "Place", "Show"],
    abbr: ["WN", "PL", "SH"]
  }
};

export const betColumnsWPS = {
  WP: [WagerTypesPos.Win, WagerTypesPos.Place],
  WS: [WagerTypesPos.Win, WagerTypesPos.Show],
  PL: [WagerTypesPos.Place],
  PS: [WagerTypesPos.Place, WagerTypesPos.Show],
  SH: [WagerTypesPos.Show],
  WPS: [WagerTypesPos.Win, WagerTypesPos.Place, WagerTypesPos.Show]
};

export const betWPS = {
  WN: [WagerTypes.Win],
  PL: [WagerTypes.Place],
  SH: [WagerTypes.Show],
  WP: [WagerTypes.Win, WagerTypes.Place],
  WS: [WagerTypes.Win, WagerTypes.Show],
  PS: [WagerTypes.Place, WagerTypes.Show],
  WPS: [WagerTypes.Win, WagerTypes.Place, WagerTypes.Show]
};
